import { ABP, eLayoutType } from '@abp/ng.core';

export const BOOKING_PAYMENT_BASE_ROUTES: ABP.Route[] = [
  {
    path: '/booking-payments',
    iconClass: 'fas fa-file-alt',
    name: '::Menu:BookingPayments',
    layout: eLayoutType.application,
    requiredPolicy: 'Mandir.BookingPayments',
    breadcrumbText: '::BookingPayments',
  },
];
